import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { CardDealService } from '../card-deal.service';
import { StorageHelper } from '../helpers/StorageHelper';
import { Global } from '../classes/Global';
import { ActivatedRoute, Router } from '@angular/router';
import { UrlValidator } from '../helpers/UrlValidater';
import { SeoService } from '../seo.service';
import { StringHelper } from '../helpers/StringHelper';

@Component({
  selector: 'app-card-deal-detail',
  templateUrl: './card-deal-detail.component.html',
  styleUrls: ['./card-deal-detail.component.scss'],
  providers: [ CardDealService ]
})
export class CardDealDetailComponent extends BaseComponent implements OnInit {

  @ViewChild('header', {static: false}) header;

  dealId: string = '';
  deal: any = null;
  isLoading = false;
  notFound = false;

  constructor(
    private cardDealService: CardDealService,
    private route: ActivatedRoute,
    private router: Router,
    private seoService: SeoService
  ) {
    super();
  }

  ngOnInit() {

    UrlValidator.validateCardDealDetailUrl(this.route, this.router);

    window.scrollTo(0,0);
    this.route.params.subscribe(params => {
      this.dealId = params['id'];
      this.loadDeal();
    });

  }

  loadDeal() {
    this.isLoading = true;
    this.notFound = false;
    this.cardDealService.getDeal(
      StorageHelper.getInstance().get(StorageHelper.keys.sessionToken),
      Global.getCountry(),
      Global.getStore(),
      this.dealId
    ).subscribe(res => {
      if (res && res['status'] != 'error') {
        this.deal = res;
        if(this.deal) {
          this.seoService.setTitle(this.deal.title);
          this.seoService.setMetaDescription(this.getString('giftCardDealsDesc'));
          this.seoService.setOGImage(this.getCardImg());

          // Set noindex for non-indexable countries
          if (!this.seoService.isIndexableCountry()) {
            this.seoService.setNoIndex(true);
          } else {
            this.seoService.setNoIndex(false);
          }
        }
      }
      else {
        this.notFound = true;
        this.seoService.setNoIndex(true);
      }
      this.isLoading = false;
    }, err => {
      this.isLoading = false;
      this.notFound = true;
      this.seoService.setNoIndex(true);
    });
  }

  getCardImg() {
    if(this.deal.cardValue == -1) {
      return "./assets/images/itunes_multiple.png";
    }
    const value = this.deal.cardValue < 10 ? 10 : this.deal.cardValue;
    const currency = Global.countries[Global.getCountry()].currency;
    if(currency == "EUR") {
      return "./assets/images/itunes_euro_" + value + ".png";
    }
    return "./assets/images/itunes_dollar_" + value + ".png";

  }

}
